import LinksCollection from "./linksCollection";

export interface IId {
    Id: string;
}

export interface IIdName {
    Id: string;
    Name: string;
}

export class Resource implements IId {
    Id: string;
    Links: LinksCollection;
}

export default Resource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/resource.ts